export type IntervalCollapse = {
	maxShownInFull: number;
	headCount: number;
	tailCount: number;
};

export const PORTAL_INTERVAL_COLLAPSE: IntervalCollapse = { maxShownInFull: 3, headCount: 1, tailCount: 1 };

export const BUILDER_INTERVAL_COLLAPSE: IntervalCollapse = { maxShownInFull: 7, headCount: 3, tailCount: 1 };

export const getIntervalCollapse = ({ count, collapse }: { count: number; collapse: IntervalCollapse }) => {
	const isCollapsible = count > collapse.maxShownInFull;
	const hiddenFrom = collapse.headCount;
	const hiddenTo = count - collapse.tailCount;

	return {
		isCollapsible,
		hiddenCount: isCollapsible ? hiddenTo - hiddenFrom : 0,
		isHidden: (index: number) => isCollapsible && index >= hiddenFrom && index < hiddenTo,
	};
};
